package pl.decks.personal.pages.ievp.sections.experience

import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import pl.decks.personal.components.widgets.timeline.Month
import pl.decks.personal.components.widgets.timeline.YearMonth
import pl.decks.personal.extensions.toSitePalette


enum class ExperienceEntry(
    val company: String,
    val location: String,
    val span: YearMonth.Range,
    val color: (ColorMode) -> Color,
    val logoBgColor: (ColorMode) -> Color? = { null },
    val profile: RoleProfile,
) {
    CREDIT_AGRICOLE(
        "Crédit Agricole",
        "Poland",
        YearMonth.Range(
            YearMonth(2018, Month.SEPTEMBER),
            YearMonth(2019, Month.JANUARY),
        ),
        color = { it.toSitePalette().profile.culture },
        profile = RoleProfile(
            roleTitle = "Data Miner",
            market = "banking",
            clients = "individual users",
            department = "Business Intelligence",
            responsibility = "provide insights about the client-base",
            stakeholders = "managerial level",
        ),
    ),
    NOKIA(
        "Nokia",
        "Poland",
        YearMonth.Range(
            YearMonth(2019, Month.JANUARY),
            YearMonth(2020, Month.AUGUST)
        ),
        color = { it.toSitePalette().profile.product },
        profile = RoleProfile(
            roleTitle = "Data Analyst",
            market = "telecommunication",
            clients = "businesses & governments",
            department = "Data Solutions",
            responsibility = "aid and optimize operations",
            stakeholders = "BTS sales partners",
        ),
    ),
    PEAK_DATA(
        "PeakData",
        "Switzerland/Remote",
        YearMonth.Range(
            YearMonth(2020, Month.OCTOBER),
            YearMonth(2021, Month.DECEMBER)
        ),
        color = { it.toSitePalette().profile.software },
        logoBgColor = { it.takeIf { it.isDark }?.toSitePalette()?.surface?.inverted()?.darkened(0.2f) },
        profile = RoleProfile(
            roleTitle = "[Lead] Data Engineer",
            market = "healthcare",
            clients = "Big Pharma",
            department = "Data Team",
            responsibility = "identify KOLs to speed up Phase III of Clinical Trials",
            stakeholders = "clients",
        ),
    ),
    WILLIAM_HILL(
        "William Hill",
        "Great Britain/Remote",
        YearMonth.Range(
            YearMonth(2022, Month.JANUARY),
            YearMonth(2022, Month.DECEMBER)
        ),
        color = { it.toSitePalette().profile.systems },
        logoBgColor = { Color.rgb(0, 0, 102) },
        profile = RoleProfile(
            roleTitle = "Data Engineer",
            market = "betting & gambling",
            clients = "individual users",
            department = "Data Operations",
            responsibility = "create toolstack to operate an Unified Data Platform",
            stakeholders = "internal data units",
        ),
    ),
    AXIOM_HEALTH(
        "Axiom Health",
        "USA/Remote",
        YearMonth.Range(
            YearMonth(2023, Month.FEBRUARY),
            YearMonth(2024, Month.JUNE)
        ),
        color = { it.toSitePalette().profile.analytics },
        profile = RoleProfile(
            roleTitle = "Lead Data Engineer",
            market = "healthcare",
            clients = "medical devices producers",
            department = "Data Team",
            responsibility = "optimize distribution of Medical Devices",
            stakeholders = "clients",
        ),
    ),
    EXURA(
        "Exura",
        "Poland/Remote",
        YearMonth.Range(
            YearMonth(2023, Month.DECEMBER),
            YearMonth(2026, Month.MAY)
        ),
        color = { it.toSitePalette().profile.platforms },
        profile = RoleProfile(
            roleTitle = "Entrepreneur/CTO",
            market = "healthcare",
            clients = "care providers",
            department = "C-level",
            responsibility = "ease the execution of medical procedures protocols",
            stakeholders = "clients, investors",
        ),
    ),
    ;
    data class RoleProfile(
        val roleTitle: String,
        val market: String,
        val clients: String,
        val department: String,
        val responsibility: String,
        val stakeholders: String,
    )
}
